<template>
  <m-pageframe :title="page_title">
    <v-container fluid class="px-md-8">
      <v-row justify="space-between" align="center" class="my-2" dense>
        <v-col cols="auto">
          <link-back text="Cancel" :fallback_route="back_route" />
        </v-col>

        <v-col cols="auto" class="d-flex align-center">
          <validation-issues-button
            :issues="validation_warnings"
            title="Issues Preventing Creation"
            :tooltip_text="tooltip_text"
            class="mr-3"
            @fix-issue="handleFixWarning"
          />
          <v-btn
            color="primary"
            :disabled="!is_form_valid"
            @click="handleCreateForm"
          >
            {{ is_re_apply_mode ? 'Apply Template' : 'Create Guest Check-In Form' }}
          </v-btn>
        </v-col>
      </v-row>

      <guest-check-in-template-selector
        ref="templateCreator"
        class="mb-10"
        :organization_id="$route.params.organization_id"
        :form_id="form_id"
        :is_re_apply_mode="is_re_apply_mode"
        @form-created="sendToEditPage"
        @cancel="$router.push(back_route)"
        @form-valid-changed="onFormValidChanged"
        @validation-warnings-changed="onValidationWarningsChanged"
      />
    </v-container>
  </m-pageframe>
</template>

<script>
import GuestCheckInTemplateSelector from '../../components/guest-check-in/guest-check-in-template-selector.vue';
import ValidationIssuesButton from '../../components/shared/validation/validation-issues-button.vue';

export default {
  name: 'GuestCheckInTemplateSelection',

  components: {
    GuestCheckInTemplateSelector,
    ValidationIssuesButton,
  },

  data() {
    return {
      is_form_valid: false,
      validation_warnings: [],
    };
  },

  computed: {
    is_re_apply_mode() {
      return this.$route.query.re_apply === 'true';
    },

    form_id() {
      return this.$route.query.form_id || null;
    },

    page_title() {
      return this.is_re_apply_mode
        ? '{organization-label}: Change Template'
        : '{organization-label}: Create Guest Check In Form';
    },

    back_route() {
      if (this.is_re_apply_mode && this.form_id) {
        return {
          name: 'guest-check-in-edit',
          params: {
            organization_id: this.$route.params.organization_id,
            guest_check_in_form_id: this.form_id,
          },
        };
      }
      return {
        name: 'search-forms-guest-check-in',
        params: { organization_id: this.$route.params.organization_id },
      };
    },

    tooltip_text() {
      if (!this.validation_warnings?.length) return '';
      const action = this.is_re_apply_mode ? 're-application' : 'creation';
      return `${this.validation_warnings.length} issue${this.validation_warnings.length !== 1 ? 's' : ''} preventing ${action}`;
    }
  },

  methods: {
    handleCreateForm() {
      if (this.$refs.templateCreator) {
        this.$refs.templateCreator.createForm();
      }
    },
    onFormValidChanged(isValid) {
      this.is_form_valid = isValid;
    },
    onValidationWarningsChanged(warnings) {
      this.validation_warnings = warnings;
    },
    handleFixWarning(warning) {
      if (this.$refs.templateCreator) {
        this.$refs.templateCreator.fixWarning(warning);
      }
    },
    sendToEditPage(guest_check_in_form_id) {
      this.$router.push({
        name: 'guest-check-in-edit',
        params: { organization_id: this.$route.params.organization_id, guest_check_in_form_id },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  max-width: 1920px;
}
</style>
